export const NAME = 'OrganizacniJednotky';
export const CRUMB_LABEL_KEY = 'edtOJ';
export { DMS_MODULE } from '../constants';

export const VOJ = 'Voj';
export const ALTERNATIVY_VOJ = 'AlternativyVoj';

export const DEPENDENT_TABLES = <const>[
	VOJ,
	ALTERNATIVY_VOJ,
];
export enum TAB_NAMES {
	HLAVNIUDAJE = 'HlavniUdaje',
	TRIPOD = 'Tripod',
	EGUI = 'eGUI',
	ABC_CATEGORY = 'ABC_CATEGORY',
	FMS_CATEGORY = 'FMS_CATEGORY',
	AUDANEXT = 'AudaNext',
	EDFS = 'EDFS',
}

export const TABS = {
	[TAB_NAMES.HLAVNIUDAJE]: { id: TAB_NAMES.HLAVNIUDAJE, labelKey: 'TabOrgUnit0' },
	[TAB_NAMES.TRIPOD]: { id: TAB_NAMES.TRIPOD, labelKey: 'TabOrgUnit1' },
	[TAB_NAMES.EGUI]: { id: TAB_NAMES.EGUI, labelKey: 'TabOrgUnit2' },
	[TAB_NAMES.ABC_CATEGORY]: { id: TAB_NAMES.ABC_CATEGORY, labelKey: 'ABC_CATEGORY' },
	[TAB_NAMES.FMS_CATEGORY]: { id: TAB_NAMES.FMS_CATEGORY, labelKey: 'FMS_CATEGORY' },
	[TAB_NAMES.AUDANEXT]: { id: TAB_NAMES.AUDANEXT, labelKey: 'AudaNext' },
	[TAB_NAMES.EDFS]: { id: TAB_NAMES.EDFS, labelKey: 'EDFS' },
};
